import React, { lazy } from 'react';
import { roleSet } from 'src/constants/role';

const ProductsSales = lazy(
  () => import('src/pages/reports/PeriodSalesPage/ProductsSales')
);
const IngredientsSales = lazy(
  () => import('src/pages/reports/PeriodSalesPage/IngredientsSales')
);

export const periodSalesTabs = [
  {
    path: 'products',
    element: <ProductsSales />,
    handle: { label: 'Товары', roles: roleSet.adminToSuperAdmin },
  },
  {
    path: 'ingredients',
    element: <IngredientsSales />,
    handle: { label: 'Экстра', roles: roleSet.adminToSuperAdmin },
  },
];
